// Dodanie sekcji do szablonu (pasek narzędzi i lewy panel edytora)
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addSection } from "../api/templatesApi";

export const useAddTemplateSection = (templateId: string) => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation((name: string) => addSection(templateId, name), {
    onSuccess: () => {
      queryClient.invalidateQueries(["Templates", templateId, "Questions"]);
    },
  });
  return mutate;
};
